export default __webpack_public_path__ + "static/cdg-99896f34a8ab7d925fafa757aa586e85.webp";